// extracted by mini-css-extract-plugin
export default {"fadeInBottomLeft":"PersonSpeechBubble_fadeInBottomLeft__mjq+9"};